// extracted by mini-css-extract-plugin
export var image = "styles-module--image--6R4vz";
export var lienNews = "styles-module--lien-news--6mtiO";
export var news = "styles-module--news--cZMkd";
export var newsContainer = "styles-module--news-container---v7si";
export var newsItem = "styles-module--news-item--453QT";